export const UserLevel=[{
    id:1,user:"Student"
},{
    id:2,user:"Admin"
}]